import { useApiClientBase } from "./apiClient";

export const useMomApi = () => {
  const { apiClient, handleError } = useApiClientBase();

  /**
   * Fetches Mom data from the backend API.
   *
   * @param data - The request payload containing filter and query parameters for the balance sheet.
   * @returns {Promise<any>} - The response data from the API, or null if an error occurs.
   */
  const getMomData = async (data: any) => {
    console.log(data, "datadatadata");
    try {
      const response = await apiClient.post(
        "/CascadingFilter/getMOMData",
        data
      );
      return response.data;
    } catch (err) {
      return handleError(err, "Fetching MOM data failed");
    }
  };

  const saveMomComments = async (data: any) => {
    console.log(data, "dataaaa");
    try {
      const response = await apiClient.post(
        "/CascadingFilter/saveMomComments",
        data
      );
      return response.data;
    } catch (err) {
      return handleError(err, "Saving MOM comments failed");
    }
  };

  return { getMomData, saveMomComments };
};
